import styles from './ImageView.module.scss';

function ImageView({
  src,
  alt,
  isFreeSize = false,
  isCircled = false,
  style,
  loading = 'lazy',
  objectFit = 'cover',
  draggable = false,
  id,
  dataTestId,
}: {
  src?: string;
  alt?: string;
  isFreeSize?: boolean;
  isCircled?: boolean;
  style?: React.CSSProperties;
  loading?: 'eager' | 'lazy';
  objectFit?: 'contain' | 'cover';
  draggable?: boolean;
  id?: string;
  dataTestId?: string;
}) {
  return (
    <div className={`${styles.componentStyle}`} style={style}>
      <img
        src={src}
        alt={alt}
        loading={loading}
        className={`${isFreeSize ? styles.isFreeSize : styles.defaultSize} ${isCircled ? styles.isCircled : ''} ${
          styles[objectFit]
        }`}
        draggable={draggable}
        id={id}
        data-testid={dataTestId}
      />
    </div>
  );
}

export default ImageView;
